import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Spinner } from '@hum/ui-library';
import { useSession } from '@hum/api/src/Session/useSession';
import { Routes } from '../state';
import { initDataDog } from '../utils/monitoring';
import { RoleController } from './RoleController';
import { useRouter } from '../hooks/useRouter';
import { V2Redirect } from './V2Redirect';
import { datadogRum } from '@datadog/browser-rum';
import { getSessionCompany, useApiQuery } from '@hum/api';

if (process.env.NODE_ENV === 'production') {
  initDataDog();
}

export function SessionController() {
  const session = useSession();
  const history = useHistory();
  const router = useRouter();
  const { data: company } = useApiQuery(getSessionCompany, {
    enabled: !!session.user?.organizationId,
  });

  useEffect(() => {
    if (session.isAuthenticated && router.pathname === Routes.LOGIN) {
      history.push(Routes.ROOT);
    }
  }, [session.isAuthenticated, router.pathname, history]);

  useEffect(() => {
    if (session.user && process.env.NODE_ENV === 'production') {
      datadogRum.setUser({
        ...session.user,
        id: session.user.id.toString(),
        name: `${session.user.firstName} ${session.user.lastName}`,
        company: {
          id: company?.id.toString(),
          name: company?.name,
          uuid: company?.uuid,
        },
      });
    }
  }, [session.user, company]);

  if (session.isLoading) return <Spinner fullScreen testId="session-spinner" />;

  if (session.isHumError) return <V2Redirect to="/error" />;

  if (!session.user || !session.isAuthenticated || session.isError)
    return <V2Redirect returnTo={`/v1${router.asPath}`} />;

  return <RoleController user={session.user} />;
}
